import React, { useState, useEffect } from "react";
import config from "../config";
import CryptoJS from "crypto-js";

const STATIC_PASSWORD = config.ENCRYPT_PASSWORD;

function EncryptPage() {
  const [showModal, setShowModal] = useState(true);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  const handleSubmit = () => {
    if (password === STATIC_PASSWORD) {
      setShowModal(false);
      setError("");
    } else {
      setError("Incorrect password");
      setPassword("");
    }
  };
  const SECRET_KEY = config.SECRET_KEY;
  function generateOneTimeToken() {
    const timestamp = Date.now();
    const nonce = CryptoJS.lib.WordArray.random(16).toString();
    const payload = `${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(payload, SECRET_KEY).toString();

    return `${timestamp}:${nonce}:${signature}`;
  }
  const callGetApi = async (url) => {
    try {
      setLoading(true);
      const tokeng = generateOneTimeToken();
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "X-Private-Key": tokeng,
        },
      });

      if (!response.ok) {
        throw new Error("API call failed");
      }

      const data = await response.json();
      console.log("API Response:", data);
      alert("API call successful");
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  // 🎯 Button handlers
  const handleAttendanceSerial = () => {
    callGetApi(`${config.API_BASE_URL}/GenerateLateralAttendanceSerial`);
  };

  const handleAdmitSerial = () => {
    callGetApi(`${config.API_BASE_URL}/GenerateLateralAdmitSerial`);
  };

  const handleRollGenerate = () => {
    callGetApi(`${config.API_BASE_URL}/GenerateLateralRollNumbers`);
  };

  const handleEligibilityUpdate = () => {
    callGetApi(`${config.API_BASE_URL}/MarkLateralCandidatesEligible`);
  };

  return (
    <>
      <style>{`
        .password-backdrop {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .password-modal {
          background: #fff;
          padding: 25px;
          width: 320px;
          border-radius: 8px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
        }
      `}</style>

      {/* 🔐 PASSWORD MODAL */}
      {showModal && (
        <div className="password-backdrop">
          <div className="password-modal">
            <h5 className="mb-3 text-center">Enter Password</h5>

            <input
              type="password"
              className="form-control mb-2"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            />

            {error && (
              <div className="text-danger mb-2 text-center">{error}</div>
            )}

            <button className="btn btn-primary w-100" onClick={handleSubmit}>
              Unlock
            </button>
          </div>
        </div>
      )}

      {!showModal && (
        <div className="container mt-5 text-center">
          <h4 className="mb-4">Secure Operations - class 10</h4>
          <button
            className="btn btn-primary btn-md m-2"
            disabled={loading}
            onClick={handleEligibilityUpdate}
          >
            Eligibility Update
          </button>
          <button
            className="btn btn-primary btn-md m-2"
            disabled={loading}
            onClick={handleRollGenerate}
          >
            Roll No. Generate
          </button>
          <button
            className="btn btn-primary btn-md m-2"
            disabled={loading}
            onClick={handleAdmitSerial}
          >
            Admit Serial No.
          </button>
          <button
            className="btn btn-primary btn-md m-2"
            disabled={loading}
            onClick={handleAttendanceSerial}
          >
            Attendance Serial No.
          </button>

          {loading && <div className="mt-3">Processing...</div>}
        </div>
      )}
    </>
  );
}

export default EncryptPage;
